import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const token = await authService.getAccessToken();
  if (token) {
    return true;
  } else {
    await router.navigate(['/auth']);
    return false;
  }
};
